import React from 'react';
import cd from 'debug';

import { AsyncOddButton } from 'modules/betslip/async';
import { MarketValue } from '../MarketsValue';

import './MarketHcpRow.scss';

const debug = cd('match-list:components:MarketHcpRow');

interface OwnProps {
    oddId: string | undefined;
    value: string;
}

type Props = OwnProps;

const MarketHcpRow: React.FC<Props> = props => {
    debug('render', props);

    const { value, oddId } = props;

    return (
        <div styleName="container" className="__app-MarketHcpRow-container">
            <MarketValue value={value} />
            <div styleName="col button">
                <AsyncOddButton oddId={oddId} showResult={true} />
            </div>
        </div>
    );
};

export default MarketHcpRow;
